import { useState } from "react";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import ArgonBox from "components/ArgonBox";
import ArgonTypography from "components/ArgonTypography";
import ArgonButton from "components/ArgonButton";
import Card from "@mui/material/Card";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TablePagination from "@mui/material/TablePagination";
import Chip from "@mui/material/Chip";
import IconButton from "@mui/material/IconButton";
import SearchIcon from "@mui/icons-material/Search";
import FilterListIcon from "@mui/icons-material/FilterList";
import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import VisibilityIcon from "@mui/icons-material/Visibility";
import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";

// Dummy data for vendors
const vendorsData = [
  {
    id: 1,
    name: "Acme Supplies Inc.",
    category: "Office Supplies",
    contactPerson: "John Doe",
    email: "john.doe@acmesupplies.com",
    phone: "(555) 123-4567",
    rating: 4.8,
    status: "Approved",
    lastOrder: "2025-04-15",
  },
  {
    id: 2,
    name: "TechPro Solutions",
    category: "IT Services",
    contactPerson: "Sarah Johnson",
    email: "sarah@techprosolutions.com",
    phone: "(555) 234-5678",
    rating: 4.5,
    status: "Approved",
    lastOrder: "2025-05-02",
  },
  {
    id: 3,
    name: "BuildRight Construction",
    category: "Construction",
    contactPerson: "Mike Williams",
    email: "mike@buildright.com",
    phone: "(555) 345-6789",
    rating: 4.2,
    status: "Pending Review",
    lastOrder: "2025-03-28",
  },
  {
    id: 4,
    name: "Global Logistics Partners",
    category: "Shipping",
    contactPerson: "Lisa Chen",
    email: "lisa.chen@globallogistics.com",
    phone: "(555) 456-7890",
    rating: 4.9,
    status: "Approved",
    lastOrder: "2025-05-10",
  },
  {
    id: 5,
    name: "Emerald Cleaning Services",
    category: "Maintenance",
    contactPerson: "Robert Garcia",
    email: "robert@emeraldcleaning.com",
    phone: "(555) 567-8901",
    rating: 4.0,
    status: "Approved",
    lastOrder: "2025-04-30",
  },
  {
    id: 6,
    name: "Precision Manufacturing Co.",
    category: "Manufacturing",
    contactPerson: "David Kim",
    email: "david@precisionmfg.com",
    phone: "(555) 678-9012",
    rating: 4.7,
    status: "Under Review",
    lastOrder: "2025-03-15",
  },
  {
    id: 7,
    name: "SecureNet Systems",
    category: "Security",
    contactPerson: "Olivia Brown",
    email: "olivia@securenetsystems.com",
    phone: "(555) 789-0123",
    rating: 4.6,
    status: "Approved",
    lastOrder: "2025-05-07",
  },
  {
    id: 8,
    name: "FreshDirect Catering",
    category: "Food Services",
    contactPerson: "James Wilson",
    email: "james@freshdirect.com",
    phone: "(555) 890-1234",
    rating: 4.3,
    status: "Approved",
    lastOrder: "2025-05-14",
  },
  {
    id: 9,
    name: "Evergreen Landscaping",
    category: "Grounds Maintenance",
    contactPerson: "Maria Rodriguez",
    email: "maria@evergreenlandscaping.com",
    phone: "(555) 901-2345",
    rating: 4.4,
    status: "Pending Review",
    lastOrder: "2025-04-05",
  },
  {
    id: 10,
    name: "InnovateTech Consulting",
    category: "Consulting",
    contactPerson: "Alex Thompson",
    email: "alex@innovatetech.com",
    phone: "(555) 012-3456",
    rating: 4.9,
    status: "Approved",
    lastOrder: "2025-05-01",
  },
];

function Vendors() {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [searchTerm, setSearchTerm] = useState("");
  const [filterAnchorEl, setFilterAnchorEl] = useState(null);
  const [selectedStatus, setSelectedStatus] = useState("All");

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value);
    setPage(0);
  };

  const handleFilterClick = (event) => {
    setFilterAnchorEl(event.currentTarget);
  };

  const handleFilterClose = (status) => {
    if (status !== undefined) {
      setSelectedStatus(status);
    }
    setFilterAnchorEl(null);
    setPage(0);
  };

  const filteredVendors = vendorsData.filter((vendor) => {
    const matchesSearch = vendor.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
      vendor.category.toLowerCase().includes(searchTerm.toLowerCase()) ||
      vendor.contactPerson.toLowerCase().includes(searchTerm.toLowerCase());
    
    const matchesStatus = selectedStatus === "All" || vendor.status === selectedStatus;
    
    return matchesSearch && matchesStatus;
  });

  const getStatusColor = (status) => {
    switch (status) {
      case "Approved":
        return "success";
      case "Pending Review":
        return "warning";
      case "Under Review":
        return "info";
      default:
        return "default";
    }
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <ArgonBox py={3}>
        <Card>
          <ArgonBox p={3} display="flex" justifyContent="space-between" alignItems="center">
            <ArgonBox>
              <ArgonTypography variant="h4" fontWeight="medium">
                Approved Vendors
              </ArgonTypography>
              <ArgonTypography variant="body2" color="text" mt={1}>
                List of preferred vendors and contractors.
              </ArgonTypography>
            </ArgonBox>
            <ArgonButton
              variant="contained"
              color="primary"
              startIcon={<AddIcon />}
            >
              Add Vendor
            </ArgonButton>
          </ArgonBox>

          <ArgonBox px={3} pb={3} display="flex" justifyContent="space-between" alignItems="center">
            <TextField
              placeholder="Search vendors..."
              variant="outlined"
              size="small"
              value={searchTerm}
              onChange={handleSearchChange}
              sx={{ width: "300px" }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon />
                  </InputAdornment>
                ),
              }}
            />
            <div>
              <IconButton onClick={handleFilterClick}>
                <FilterListIcon />
              </IconButton>
              <Menu
                anchorEl={filterAnchorEl}
                open={Boolean(filterAnchorEl)}
                onClose={() => handleFilterClose()}
              >
                <MenuItem onClick={() => handleFilterClose("All")}>All</MenuItem>
                <MenuItem onClick={() => handleFilterClose("Approved")}>Approved</MenuItem>
                <MenuItem onClick={() => handleFilterClose("Pending Review")}>Pending Review</MenuItem>
                <MenuItem onClick={() => handleFilterClose("Under Review")}>Under Review</MenuItem>
              </Menu>
            </div>
          </ArgonBox>

          <TableContainer>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Vendor Name</TableCell>
                  <TableCell>Category</TableCell>
                  <TableCell>Contact Person</TableCell>
                  <TableCell>Rating</TableCell>
                  <TableCell>Status</TableCell>
                  <TableCell>Last Order</TableCell>
                  <TableCell align="right">Actions</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {filteredVendors
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((vendor) => (
                    <TableRow key={vendor.id}>
                      <TableCell>
                        <ArgonTypography variant="body2" fontWeight="medium">
                          {vendor.name}
                        </ArgonTypography>
                      </TableCell>
                      <TableCell>{vendor.category}</TableCell>
                      <TableCell>
                        <div>{vendor.contactPerson}</div>
                        <ArgonTypography variant="caption" color="text">
                          {vendor.email}
                        </ArgonTypography>
                      </TableCell>
                      <TableCell>
                        <ArgonTypography
                          variant="body2"
                          fontWeight={vendor.rating >= 4.5 ? "bold" : "regular"}
                          color={vendor.rating >= 4.5 ? "success" : "text"}
                        >
                          {vendor.rating}/5.0
                        </ArgonTypography>
                      </TableCell>
                      <TableCell>
                        <Chip
                          label={vendor.status}
                          color={getStatusColor(vendor.status)}
                          size="small"
                        />
                      </TableCell>
                      <TableCell>{vendor.lastOrder}</TableCell>
                      <TableCell align="right">
                        <IconButton size="small">
                          <VisibilityIcon fontSize="small" />
                        </IconButton>
                        <IconButton size="small">
                          <EditIcon fontSize="small" />
                        </IconButton>
                        <IconButton size="small">
                          <DeleteIcon fontSize="small" />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  ))}
              </TableBody>
            </Table>
          </TableContainer>
          
          <TablePagination
            rowsPerPageOptions={[5, 10, 25]}
            component="div"
            count={filteredVendors.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Card>
      </ArgonBox>
      <Footer />
    </DashboardLayout>
  );
}

export default Vendors;